import React, {useState, useRef, useEffect} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge,Spinner,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
} from "reactstrap";
import { useSelector , useDispatch} from 'react-redux'

import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
    floattest, numtest} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'

import Select from "react-select";
import dp from "../../images/dp.jpg"

function Brand(props) {
    const [showProcessing , setShowProcessing] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [selectedbrand, setSelectedBrand] = useState({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : ""
    })

    const [{alt, src}, setImg] = useState({
        src: dp,
        alt: ''
      });
      const [alert, setAlert] = React.useState(null);
    const [filenames, setFilenames] = useState()
    const hiddenFileInput = useRef(null);
    
    useEffect(() => {
      populatebrands()
    },[])
    
    

    const populatebrands = () => {
      setShowProcessing(true)
        props.API.get(`tenant/getbrands`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            setBrandList(res.data.map((r, key) => {
                return {
                    ...r, value : r.bid, label : r.bname.en,
                    blogo : r.blogo, key : key
                }
            }))
            setShowProcessing(false)
                          
          }).catch(function (error) {
            setShowProcessing(false)
              
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              props.swal("Error getting brand data")
            }
             
          }) 
    }

    const cinputConfirmAlert = (xcc) => {
      swal({
        title: "Are you sure?",
        text: "do you want to update brand?",
        icon: "warning",
        dangerMode: true,
      })
      .then(willDelete => {
        if (willDelete) {
          updbrand()
        }
      });
   };  

      const handleClick = event => {
        hiddenFileInput.current.click();
      };
   
    

    const handleImg = (e) => {
    
        if(e.target.files[0]) {
                
            if(filenamevalid(e.target.files[0])){
              setFilenames(e.target.files[0])
              setImg({
                src: URL.createObjectURL(e.target.files[0]),
                alt: e.target.files[0].name
            });
            }else{
              props.swal("Invalid Filename")
            }
        }
     
          
    }

    const updbrand = () => {
      if(fieldvalidator(selectedbrand.bname.en )){
        props.swal("Required Fields are EMPTY!")
        return 
      }
        setShowProcessing(true)
        let formData = new FormData(); 
        formData.append("blogo" , filenames)
        formData.append('brand' , JSON.stringify(selectedbrand))
        props.API({
            method: "post",
            url : `tenant/ubrand`,
            data: formData,
            headers : {"arixauth" : localStorage.getItem("arixauth")}
            }).then((res) => {
          //    props.swal("Brand Updated!")
              setShowProcessing(false)
            }).then(xx => {
              window.location.reload(false)
            }).catch(function (error) {
              setShowProcessing(false)   
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }
             
               
        }) 

    }

    const showTiles = () => {
        try{
            return (
                <Row>
                    {
                        brandList.map((br,key) => {
                            return (
                                <Col md="3" key={key}>
                                     <Card>
                                        <CardHeader>{  <img className="mute-anim" src = {`${br.blogo}`} alt={"..."} width="200px" />}</CardHeader>
                                        <CardBody>
                                            <center>
                                            <label>{br.bname.en}</label>< br />
                                            <label>{br.bname.ar}</label>< br />
                                            <label>{br.bname.fr}</label>
                                            </center>
                                        </CardBody>
                                     </Card>
                                </Col>
                             
                            )     
                         })
                    }

                </Row>
            )
        }catch(e){
            return (
                    <h6 style={{textAlign : "center"}}>Please refresh list...</h6>
                )
        }
       
    }

     return (
      
        <div className="content">
             

             <input
         ref={hiddenFileInput}
         type="file" 
         accept=".png, .jpg, .jpeg" 
         id="photo" 
         className="visually-hidden"
         onChange={e=> handleImg(e)}
         hidden/>


        <Row>
            {/** This will contain Table */}
            <Col sm="12" md="4">
            {showProcessing && props.Spin}
            
             <Card>
                 <CardHeader>
                 <Row>
                         <Col >
                         <FormGroup>
                               <label>Select Brand {selectedbrand.bname.en !== "" && " Code : " +  selectedbrand.bid}</label>
                               <i className="fa fa-refresh" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={f => populatebrands()}/>
                                     <Select options={brandList} styles={customStyles} 
                                            value={{label : selectedbrand.bname.en + ' ' + selectedbrand.bname.ar, value : selectedbrand.bname.bid}} 
                                            onChange={e=> {
                                                    
                                                    setSelectedBrand(
                                                        {
                                                            bid : e.bid, bname : e.bname,
                                                            blogo : e.blogo
                                                        }
                                                    );
                                               
                                                    setImg({src : `${process.env.REACT_APP_APIURL}/brands/${e.blogo}`})
                                                    }}
                                            />
                               
                         </FormGroup>
                      
                         </Col>
                 </Row>
                 <hr />
                 <Row>
                 <Col>
                 <center>
                   <img className="mute-anim" src = {src} alt={"..."} width="150px"  onClick={e => {
                                handleClick(e)
                              }}/>
                   </center>
                 </Col>   
                 </Row>     
                                           
                 <Row>
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>Name EN</label>
                             <Input
                             maxLength={20}
                             value = {selectedbrand.bname.en}
                             placeholder="Brand Name"
                             type="text"
                              onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, en : t.target.value}})
                                
                                }
                            }
                              
                             />
                         </FormGroup>
                         </Col>{/** 
                         <Col className="pr-1" md="4">
                         <FormGroup>
                             <label>Nom</label>
                             <Input
                           value = {selectedbrand.bname.fr}
                           maxLength={20}
                             placeholder="Nom"
                             type="text"
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, fr : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>*/}
                         <Col className="pr-1" md="6">
                         <FormGroup>
                             <label>اسم</label>
                             <Input
                             maxLength={20}
                              value = {selectedbrand.bname.ar}
                             placeholder="اسم"
                             type="text"
                             onChange={t => {
                                setSelectedBrand({...selectedbrand , bname : {...selectedbrand.bname, ar : t.target.value}})
                              }}
                             />
                         </FormGroup>
                         </Col>
                  </Row>
                 
           
                 </CardHeader>
                 <CardBody>
               
                 </CardBody>
                 <CardFooter>
                     <Button size="sm" color="primary" onClick={x => {setSelectedBrand({
                           bid : "", bname : {en : "", fr :"", ar : ""},
                             blogo : ""
                              });
                              setImg({
                                src: dp,
                                alt: ''
                              })
                              }} >New Brand</Button>{' '}
                     <Button size="sm" color="warning" style={{float : "right"}} onClick={x => {
                        cinputConfirmAlert()
                     }}>Update</Button>
                 </CardFooter>
             </Card>
         </Col>
            <Col sm="12" md="8">
                <Container style={{height : "700px" , overflowY : "auto"}}>
                {showTiles()}
                </Container>
            
            </Col>
        
        </Row>
        </div>
    )
}

export default Brand;